import { BannerLayout } from '../Shares/BannerLayout';
import { CasinoBannerSlide } from './CasinoBannerSlide';
export const CasinoBanner: React.FC = () => {
  return <BannerLayout>
      <CasinoBannerSlide />
      <CasinoBannerSlide />
      <CasinoBannerSlide />
      <CasinoBannerSlide />
    </BannerLayout>;
};